import { Component, OnInit, ViewChild } from '@angular/core';
import { UsuarioService } from '../../services/usuario.service';
import { ClienteService } from '../../services/cliente.service';
import { FormControl } from '@angular/forms';
import { NuevoUsuarioViewModel } from '../../models/viewmodels/UsuarioViewmodel';
import { Observer } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { DoubleBounceComponent } from '../../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../../shared/custom-alert/custom-alert.component';

import { RolViewModel } from '../../models/viewmodels/rolViewModel';
import { ClienteViewModel } from '../../models/viewmodels/ClienteViewModel';

import { Router } from '@angular/router'

@Component({
  selector: 'app-nuevo-usuario',
  templateUrl: './nuevo-usuario.component.html',
  styleUrls: ['./nuevo-usuario.component.scss']
})
export class NuevoUsuarioComponent implements OnInit {

  roles: Observable<RolViewModel[]>;

  public tags:Array<ClienteViewModel> = [];
  public clientes:Array<ClienteViewModel> = [];

  public autocompleteItems = [];
  usuario: NuevoUsuarioViewModel = new NuevoUsuarioViewModel();
  public checkRol = [];

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  errores = new Array();

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private usuarioService: UsuarioService, private clienteService: ClienteService, private router: Router) {
  }

  ngOnInit() {
    this.spinner.isRunning = false;
    this.roles = this.usuarioService.obtenerRoles();
  }

  filtrar(event) {    
    if (event.query.length > 3) {
      return this.clienteService.listado(0, 10, event.query).subscribe(response => {        
        this.clientes = response.clientes;        
      });

    }
  }

  customTrackBy(index: number, rol: RolViewModel): any {
    return rol.id;
  }

  rolSeleccionado(event: any, rol: RolViewModel) {
    if (event.target.checked) {
      this.usuario.roles.push(rol);
    } else {
      this.usuario.roles = this.usuario.roles.filter(r => r.id != rol.id);
    }
  }

  onSubmit() {
    this.spinner.isRunning = true;
    this.alert.visible = false;
    
    this.usuario.clientes = this.tags;

    this.usuarioService.guardar(this.usuario)
      .map(result => {
        this.alert.visible = true;
        this.alert.titulo = "Nuevo usuario";
        if (result.status == 201) {
          this.alert.tipo = "success"
          this.alert.mensaje = "El usuario se ha creado correctamente"
          this.usuario = new NuevoUsuarioViewModel();
          this.tags = [];
        } else {
          this.alert.tipo = "danger"
          this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo."
        }
        this.alertComponent.setType(this.alert.tipo);
        this.spinner.isRunning = false;        
        for (var i = 0; i < this.checkRol.length; i++) {
          this.checkRol[i] = false;
        }
      })
      .subscribe(data => {

      }, error => {
        var json = error.json();
        this.spinner.isRunning = false;
        this.alert.visible = true;
        this.alert.titulo = "Nuevo usuario";
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
        this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo."
        if (json.modelState) {
          for (var key in json.modelState) {
            if (json.modelState[key].length == 1) {
              this.errores.push(json.modelState[key]);
            } else {
              for (var i = 0; i < json.modelState[key].length; i++) {
                this.errores.push(json.modelState[key][i]);
              }
            }
          }
        }
      });
  }

  volver() {
    this.router.navigate(['dashboard/clientes']);
  }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/usuarios/nuevo-usuario/nuevo-usuario.component.ts